import { Box, Container, Heading, Text, VStack } from "@chakra-ui/react";

import { useI18n } from "@/i18n";
import { PageShell } from "@/shared/layout/PageShell";

interface LegalPageProps {
  readonly kind: "privacy" | "terms";
}

export function LegalPage({ kind }: LegalPageProps) {
  const { copy } = useI18n();
  const title =
    kind === "privacy" ? copy.legal.privacyTitle : copy.legal.termsTitle;
  const sections =
    kind === "privacy"
      ? copy.legal.privacySections
      : copy.legal.termsSections;

  return (
    <PageShell>
      <Box as="main" pt={{ base: 28, md: 32 }} pb={20}>
        <Container maxW="860px">
          <Text color="nvp.cyan" fontWeight={900} textTransform="uppercase">
            NVP Games
          </Text>
          <Heading as="h1" fontSize={{ base: "3rem", md: "4.6rem" }} mt={4}>
            {title}
          </Heading>
          <Text color="whiteAlpha.700" mt={3}>
            {copy.legal.updated}
          </Text>
          <VStack align="stretch" spacing={8} mt={12}>
            {sections.map((section) => (
              <Box
                key={section.title}
                border="1px solid"
                borderColor="whiteAlpha.200"
                borderRadius="8px"
                bg="rgba(16, 19, 37, 0.62)"
                p={{ base: 5, md: 7 }}
              >
                <Heading as="h2" fontSize="2xl" mb={4}>
                  {section.title}
                </Heading>
                <VStack align="stretch" spacing={3}>
                  {section.body.map((paragraph) => (
                    <Text key={paragraph} color="whiteAlpha.800" lineHeight={1.75}>
                      {paragraph}
                    </Text>
                  ))}
                </VStack>
              </Box>
            ))}
          </VStack>
        </Container>
      </Box>
    </PageShell>
  );
}
